import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createInvite, type CreateInviteInput } from '../api/team.api';
import { teamKeys } from './team.keys';

/**
 * Send a team invite (MYN-43). On success refreshes the invites list so the
 * new pending invite appears. Domain restriction is enforced server-side; the
 * caller surfaces INVITE_DOMAIN_MISMATCH inline. `sectorId` (MYN-202) is optional
 * and Investor-only.
 */
export function useInviteMember(entityId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateInviteInput) => createInvite(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: teamKeys.invites(entityId) });
    },
  });
}
